import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { LoginGuard } from "./core/guards/login.guard";
import { IRouteData } from "./shared/shared.interface";

const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    loadChildren: () => import("./authentication/login-page/login-page.module").then((m) => m.LoginPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: "dashboard",
    loadChildren: () => import("./dashboard/dashboard-page.module").then((m) => m.DashboardPageModule),
    canActivate: [AuthGuard],
    data: {
      canBeLanding: true,
    } as IRouteData,
  },
  {
    path: "error",
    loadChildren: () => import("./error/error-page.module").then((m) => m.ErrorPageModule),
  },
  { path: "**", loadChildren: () => import("./not-found/not-found-page.module").then((m) => m.NotFoundPageModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
